import { useMutation } from '@tanstack/react-query';
import nanoid from 'nanoid';

import container from '../../../../container';
import { currencies } from '../claimsHelpers';
import { useClaimsShopSettings } from '../../ClaimsShopSettingsContext';

type OnChangeFn = (payload: Record<string, unknown>) => void;

const useInvoiceExtraction = (onChange: OnChangeFn) => {
  const shopSettings = useClaimsShopSettings();

  const { isLoading, mutate, isError } = useMutation({
    mutationFn: async (fileId: number) => container.touchpointsApi.getInvoiceExtraction(fileId),
    onSuccess: (data) => {
      const { netValue, netValueCurrency, orderItems, taxRate } = data;

      if (netValueCurrency && currencies.includes(netValueCurrency)) {
        onChange({ netValueCurrency });
      }

      onChange({
        netValue,
        taxRate: taxRate ? taxRate * 100 : null,
        orderItems: orderItems.map((item) => ({
          id: nanoid(),
          description: item.name ? item.name.replace(/\s+/g, ' ').trim().substring(0, 50).split(/,|;/)[0] : '',
          unitPrice: String(item.price || 0),
          quantity: String(Math.floor(item.quantity || 0)),
        })),
      });
    },
  });

  const extractInvoiceData = (fileId: number) => {
    if (shopSettings.isInvoiceExtractionEnabled) {
      mutate(fileId);
    }
  };

  return {
    isExtractingInvoice: isLoading,
    extractInvoiceData,
    isFailedToExtractInvoice: isError,
  };
};

export default useInvoiceExtraction;
